import { Component, OnInit } from '@angular/core';
import { NavService } from '../../services/nav.service';

@Component({
  selector: 'app-full-layout',
  templateUrl: './full-layout.component.html',
  styleUrls: ['./full-layout.component.scss']
})
export class FullLayoutComponent implements OnInit {

  constructor(
    public navServices: NavService                                 
  ) { }

  ngOnInit(): void {
  }

  hoverEffect($event: MouseEvent): void {
    const body = document.body;
    if (!body.classList.contains('main-sidebar-hide')) {
      return;
    }
    if ($event.type === 'mouseover') {
      body.classList.add('main-sidebar-open');
    } else {
      body.classList.remove('main-sidebar-open');
    }
  }

  clickonBody(): void {
    const body = document.body;
    body.classList.remove('main-sidebar-open');
    body.classList.remove('main-sidebar-show');
    if (window.innerWidth < 991) {
      this.navServices.collapseSidebar = false;
    }
  }

}